import UploadErrorImg from "@assets/images/UploadFileError.svg";
import { makeStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { DialogProps } from "@saleor/types";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  {
    fileErrorIcon: {
      alignContent: "center",
      display: "flex",
      justifyContent: "center",
      paddingBottom: "25px"
    },
    text: {
      margin: 0,
      textAlign: "center"
    }
  },
  { name: "UploadErrorDialog" }
);

export interface UploadErrorDialogDialogProps extends DialogProps {
  open: boolean;
  loading: boolean;
  uploadErrorLink?: string;
}

// To re-use this component, also add the ff
// const [uploadErrorLink, setUploadErrorLink] = React.useState(null);
// setUploadErrorLink(jobData.data?.productUploadJob?.errorFileUrl); Redirect the download link with this
// Note: Empty_File error doesnt sent URL links

const UploadErrorDialog: React.FC<UploadErrorDialogDialogProps> = props => {
  const { onClose, open, loading, uploadErrorLink } = props;

  const classes = useStyles(props);

  return (
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth="sm"
      fullWidth
      disableBackdropClick={loading}
    >
      <>
        <DialogTitle>
          <FormattedMessage
            defaultMessage="Upload Error"
            description="Upload Error, dialog header"
          />
        </DialogTitle>
        <DialogContent>
          <div className={classes.fileErrorIcon}>
            <img alt="Upload file error image" src={UploadErrorImg} />
          </div>
          <p className={classes.text}>
            Oops! We've encountered some format issues on the file you've
            uploaded. An error file was automatically sent to your registered
            email address.
          </p>
          <br />
          <p className={classes.text}>
            You can also download the error file{" "}
            <a href={uploadErrorLink} target="_blank">
              here
            </a>
          </p>
        </DialogContent>
      </>
    </Dialog>
  );
};

UploadErrorDialog.displayName = "UploadErrorDialog";
export default UploadErrorDialog;
